import Axios, { AxiosError, InternalAxiosRequestConfig, AxiosRequestConfig } from 'axios';
import { getAccessToken } from './login';
type RequestConfig<T extends InternalAxiosRequestConfig | AxiosRequestConfig> = T & {
	skipTokenInjection?: boolean;
};

const axiosInstance = Axios.create();

export const apiPigeonMutator = <T>(
	config: AxiosRequestConfig,
	options?: RequestConfig<AxiosRequestConfig>
): Promise<T> => {
	const baseUrl = process.env.PIGEON_API_URL ?? 'https://notifications-api.cogvio.com/api/v1/';

	axiosInstance.defaults.baseURL = baseUrl;

	axiosInstance.defaults.headers.post['Content-Type'] = 'application/json';
	axiosInstance.defaults.headers.put['Content-Type'] = 'application/json';

	return axiosInstance({ ...config, ...options }).then(({ data }) => data);
};

const requestIntercept = async (request: RequestConfig<InternalAxiosRequestConfig>) => {
	const accessToken = process.env.ACCESS_TOKEN ?? getAccessToken();
	const authProvider = process.env.PIGEON_AUTH_PROVIDER ?? 'app-pm@cogvio.com';

	if (!request.skipTokenInjection) {
		if (request.headers) {
			request.headers['accept-encoding'] = 'gzip, deflate, br';
			request.headers['accept-language'] = 'en-GB,en;q=0.6';
			request.headers['content-type'] = 'application/json';
			request.headers['x-cogvio-auth-provider'] = authProvider;
			if (accessToken) {
				request.headers['x-cogvio-auth-token'] = accessToken;
			}
		}
	}

	return request;
};

axiosInstance.interceptors.request.use(requestIntercept, (error) => Promise.reject(error));

export type ErrorType<Error> = AxiosError<Error>;
